export const INSPECTION = '/inspections'
